// MetricsChart — T054

import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

interface ChartMetric {
  timestamp: string;
  responseTimeMs: number;
  statusCode: number;
  state?: string;
}

interface MetricsChartProps {
  metrics: ChartMetric[];
}

export default function MetricsChart({ metrics }: MetricsChartProps) {
  if (metrics.length === 0) {
    return (
      <div className="bg-surface rounded-lg p-8 text-center text-text-muted">
        No metrics data available
      </div>
    );
  }

  const data = metrics
    .slice()
    .sort((a, b) => new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime())
    .map((m) => ({
      time: new Date(m.timestamp).toLocaleTimeString(),
      responseTime: m.responseTimeMs,
      statusCode: m.statusCode,
      state: m.state,
    }));

  return (
    <div className="bg-surface rounded-lg p-4">
      <h3 className="text-text-primary text-h2 mb-4">Response Time</h3>
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" stroke="#334155" />
          <XAxis dataKey="time" stroke="#cbd5e1" fontSize={12} />
          <YAxis stroke="#cbd5e1" fontSize={12} unit="ms" />
          <Tooltip
            contentStyle={{ backgroundColor: '#1e293b', border: '1px solid #334155', borderRadius: '8px' }}
            labelStyle={{ color: '#f8fafc' }}
            itemStyle={{ color: '#cbd5e1' }}
          />
          <Line
            type="monotone"
            dataKey="responseTime"
            stroke="#1d4ed8"
            strokeWidth={2}
            dot={false}
            activeDot={{ r: 4 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
